import React, {Component} from 'react';

import cl from 'classnames';
import s from './Loader.css';

class Loader extends Component {
  render() {
    const {text, color, className, style} = this.props;

    return (
      <div className={cl(s.SK_Loader, 'SK_Loader', className)} style={style}>
        <style>
          {`
            .SK_Loader {
              --test-color: ${color || '#ea4154'};
              }
            `}
        </style>
        <div className={cl(s.SK_LdsRing, 'SK_LdsRing')}>
          <div />
          <div />
          <div />
          <div />
        </div>

        <p>{text}</p>
      </div>
    );
  }
}

export {Loader};
